import { createPromiseClient } from '@bufbuild/connect-web';
import { transport } from '../transport';
import { BuildingManager } from '@/generated/msh/service/v1/structure_manager_connectweb';
import { AlertManager } from '@/generated/msh/service/v1/alert_manager_connectweb';
import { GetBuildingAlertsRequest } from '@/generated/msh/service/v1/structure_manager_pb';
import { GetAlertsRequest } from '@/generated/msh/service/v1/alert_manager_pb';

const clientBuilding = createPromiseClient(BuildingManager, transport);
const clientStructure = createPromiseClient(AlertManager, transport);

export async function fetchBuildingAlerts(
  { parentId, filter, pagination },
  signal
) {
  const response = await clientBuilding.getBuildingAlerts(
    new GetBuildingAlertsRequest({
      buildingId: parentId,
      filter,
      page: {
        cursor: pagination?.cursor || '',
        perPage: '9999',
      },
    }),
    { signal }
  );

  const alerts = response.alerts;
  const meta = response.page;

  return { alerts, meta };
}

export async function fetchStructureAlerts(
  { parentId, filter, pagination },
  signal
) {
  const response = await clientStructure.getAlerts(
    new GetAlertsRequest({
      structureId: parentId,
      filter,
      page: {
        cursor: pagination?.cursor || '',
        perPage: '9999',
      },
    }),
    { signal }
  );

  const alerts = response.alerts;
  const meta = response.page;

  return { alerts, meta };
}
